import { F0Box, F0Button, F0Icon, F0Text } from '@factorialco/f0-react'
import { Spinner } from '@factorialco/f0-react/dist/experimental'
import InfoCircle from '@factorialco/f0-react/icons/app/InfoCircle'

import { usePrivateIntegrationsSyncContext } from 'modules/integrations/hooks/SyncContext'

export const SyncBar = () => {
  const { isSyncing } = usePrivateIntegrationsSyncContext()

  // TODO: Replace with useSyncBarAction once sync action hook is implemented
  const handleClick = () => {}

  // TODO: Replace with useSyncBarData once data hook is wired
  const syncStatus = 'Syncing'
  const statusCounts = [
    { status: 'pending', count: 14, label: 'pending' },
    { status: 'syncing', count: 4, label: 'syncing' },
    { status: 'synced', count: 32, label: 'synced' },
    { status: 'failed', count: 2, label: 'failed' },
  ]

  return (
    <F0Box
      display="flex"
      flexDirection="row"
      alignItems="center"
      justifyContent="between"
      paddingX="lg"
      paddingY="sm"
      background="primary"
      borderRadius="md"
      gap="md"
    >
      <F0Box display="flex" flexDirection="row" alignItems="center" gap="md">
        {syncStatus && (
          <F0Box display="flex" flexDirection="row" alignItems="center" gap="xs">
            <F0Icon icon={InfoCircle} size="sm" color="default" />
            <F0Text variant="body" markdown={false} content={syncStatus} />
          </F0Box>
        )}
        {statusCounts.length > 0 && (
          <F0Box display="flex" flexDirection="row" alignItems="center" gap="sm">
            {statusCounts.map((counter, index) => (
              <F0Box
                key={counter.status}
                display="flex"
                flexDirection="row"
                alignItems="center"
                gap="sm"
              >
                {index > 0 && <F0Text variant="description" markdown={false} content="|" />}
                <F0Text
                  variant="body"
                  markdown={false}
                  content={`${counter.count} ${counter.label}`}
                />
              </F0Box>
            ))}
          </F0Box>
        )}
      </F0Box>
      {/* // TODO: relplace with syncBarAction once sync action hook is implemented*/}
      <F0Button
        variant="outline"
        icon={Spinner}
        label="Syncing"
        onClick={handleClick}
        loading={false}
      />
    </F0Box>
  )
}
